import {
  ButtonPrimary,
  ButtonsContainer,
  ButtonSecondary,
  DetailsFormContent,
  FileBox,
  FormFooter,
  GridTemplate,
  Prompt
} from '@app/shared/components';
import {
  PrivacyPolicyDetailFormModel,
  privacyPolicyDetailFormSchema
} from '@domain/privacy-policy/models/shared/privacyPolicyDetailForm';
import { PDF_ALLOWED_EXTENSIONS } from '@domain/privacy-policy/models/shared/privacyPolicyDetailFormConstraints';
import { yupResolver } from '@hookform/resolvers';
import React, { ReactElement } from 'react';
import { useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { PrivacyPolicyFileUpload } from './PrivacyPolicyFileUpload';

interface PrivacyPolicyDetailFormProps {
  onSubmit: (data: PrivacyPolicyDetailFormModel) => Promise<void>;
  onCancel: () => void;
}

export const PrivacyPolicyDetailForm = ({
  onSubmit,
  onCancel
}: PrivacyPolicyDetailFormProps): ReactElement => {
  const { t } = useTranslation('privacy-policy');

  const [fileName, setFileName] = React.useState<string>('');

  const { register, handleSubmit, errors, formState } = useForm<
    PrivacyPolicyDetailFormModel
  >({
    resolver: yupResolver(privacyPolicyDetailFormSchema),
    mode: 'all'
  });

  const onUploadFiles = (files: File[]): void => {
    if (files && files.length) {
      setFileName(files[0].name);
    }
  };

  return (
    <Prompt
      hasChanges={
        formState.isDirty &&
        !formState.isSubmitting &&
        !formState.isSubmitSuccessful
      }>
      <form onSubmit={handleSubmit(onSubmit)} autoComplete='off'>
        <DetailsFormContent>
          <GridTemplate>
            <FileBox
              name='pdfFile'
              accept={PDF_ALLOWED_EXTENSIONS.join(',')}
              onUploadFiles={onUploadFiles}
              innerRef={register}>
              <PrivacyPolicyFileUpload
                fileName={fileName}
                error={errors?.pdfFile}
              />
            </FileBox>
          </GridTemplate>
        </DetailsFormContent>
        <FormFooter>
          <ButtonsContainer>
            <ButtonSecondary
              type='button'
              onClick={onCancel}
              disabled={formState.isSubmitting}
              label={t('shared:generics.cancel')}
            />
            <ButtonPrimary
              type='submit'
              disabled={formState.isSubmitting || !formState.isDirty}
              label={t('shared:generics.save')}
            />
          </ButtonsContainer>
        </FormFooter>
      </form>
    </Prompt>
  );
};
